import { Component } from '@angular/core';
import { ToastMessageOptions, MessageService } from 'primeng/api';

@Component({
    selector: 'agpr-growler',
    templateUrl: './growler.component.html',
    styleUrls: ['./growler.component.scss'],
    standalone: false
})
export class GrowlerComponent {
    public messages: ToastMessageOptions[] = [];

    constructor(private messageService: MessageService) {
        this.messageService.messageObserver.subscribe(
            messages => {
                if (Array.isArray(messages)) {
                    this.messages.push(...messages);

                } else if (messages) {
                    this.messages.push(messages);

                } else {
                    this.messages = [];
                }

            }
        );
    }
}
